import { ReactComponent as RusLogo } from "../../assets/logos/rus_svg.svg";
import { ReactComponent as SancorLogo } from "../../assets/logos/sancor_svg.svg";
import { ReactComponent as TerrawindLogo } from "../../assets/logos/terrawind_black.svg";
import { ReactComponent as ZurichLogo } from "../../assets/logos/zurich_svg.svg";
import { ReactComponent as FedPatLogo } from "../../assets/logos/federacion_patronal_logo.svg";
import { ReactComponent as ExpertaLogo } from "../../assets/logos/experta_logo.svg";
import { ReactComponent as RivadaviaLogo } from "../../assets/logos/rivadavia_logo.svg";
import PropTypes from "prop-types";
import "./CompanyLogo.css";

const COMPANY_LOGO_COMPONENTS = {
    Sancor: SancorLogo,
    RUS: RusLogo,
    Zurich: ZurichLogo,
    Terrawind: TerrawindLogo,
    Federacion_Patronal: FedPatLogo,
    Experta: ExpertaLogo,
    Rivadavia: RivadaviaLogo,
};

const COMPANY_LOGO_CLASS_NAMES = {
    Sancor: "CompanyLogo__logo --sancor",
    RUS: "CompanyLogo__logo",
    Zurich: "CompanyLogo__logo",
    Terrawind: "CompanyLogo__logo --terrawind",
    Federacion_Patronal: "CompanyLogo__logo",
    Experta: "CompanyLogo__logo --experta",
    Rivadavia: "CompanyLogo__logo",
};

const CompanyLogo = ({company}) => {
    const Logo = COMPANY_LOGO_COMPONENTS[company];
    if (!Logo) {
        return null;
    }

    return (
        <div className="CompanyLogo__container">
            <Logo className={COMPANY_LOGO_CLASS_NAMES[company] || "CompanyLogo__logo"}/>
        </div>
    );
};

CompanyLogo.propTypes = {
    company: PropTypes.string,
};

export default CompanyLogo;
